import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useOrderByCode(params) {
  return useSWR(
    params?.code
      ? {
          path: "/api/v1/orders/code",
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useOrderByCode;
